import { Component, Input, OnInit } from '@angular/core';

import { Modal } from 'bootstrap';
import { Data2Service } from 'src/app/common/data2.service';
import { InfoboxService } from 'src/app/common/infobox/infobox.service';
import { UuidService } from 'src/app/common/uuid.service';

@Component({
	selector: 'app-drivers-event-add',
	templateUrl: './drivers-event-add.component.html',
	styleUrls: ['./drivers-event-add.component.css'],
})
export class DriversEventAddComponent implements OnInit {
	@Input() event;
	protected itemsBeforeDataLoad = 3;
	data = {
		id: this.uuid.generate(),
		drivers: null,
		date_from: null,
		date_to: null,
		type: null,
		comments: null,
		status: 1,
	};
	drivers: Array<any> = [];
	driver = [];
	types: Array<any> = [];
	returnDate = '';
	kind = null;
	driverKind = null;
	date_from = null;
	date_to = null;

	constructor(
		private readonly api: Data2Service,
		protected uuid: UuidService,
		protected infobox: InfoboxService,
	) {}

	ngOnInit(): void {
		this.api.get('/driversEventsTypes/', (result, error) => {
			this.types = result.data;
			this.loadData();
		});
		this.api.get('/drivers/', (result, error) => {
			this.drivers = result.data;
			this.loadData();
		});
	}

	loadData() {
		this.itemsBeforeDataLoad--;
		if (this.itemsBeforeDataLoad > 0) {
			return;
		}
	}

	openModal(kind, typeDriver) {
		new Modal(document.getElementById('driversEventAdd')).show();
		switch (typeDriver) {
			case typeDriver:
				this.driver = this.event[typeDriver].map((obj) => obj.driver);
				break;
		}
		switch (kind) {
			case 'before':
				this.date_from = null;
				this.date_to = this.event.date_from;

				break;
			case 'after':
				this.date_from = this.event.date_to;
				this.date_to = null;
				break;
		}

		this.data = {
			id: this.uuid.generate(),
			drivers: this.driver,
			date_from: this.date_from,
			date_to: this.date_to,
			type: null,
			comments: null,
			status: 1,
		};
	}

	save(data) {
		this.api.post('/driversEvents/' + data.id + '/', data, (result, error) => {
			if (error) {
				return;
			}
		});
		this.dialogClose();
	}

	dialogClose(): void {
		const modal = Modal.getInstance(document.getElementById('driversEventAdd'));
		if (!modal) {
			return;
		}
		this.data = {
			id: this.uuid.generate(),
			drivers: null,
			date_from: null,
			date_to: null,
			type: null,
			comments: null,
			status: 1,
		};
		modal.hide();
	}
}
